import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthMutation } from '../auth-http-client';
import { uuidResponseSchema } from '../types';

export type DepositCashdeskMutationParams = {
	cashdeskId: number;
	amount: number;
	note?: string;
};

export const createDepositCashdeskMutation = () =>
	createAuthMutation({
		params: declareParams<DepositCashdeskMutationParams>(),
		request: {
			method: 'POST',
			url: '/cashdesk/replenish',
			body: (data) => data,
		},
		response: {
			contract: zodContract(uuidResponseSchema),
		},
	});
